import React from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import requireLogin from "helpers/requireLogin";
import "./HeroConvergence.css";

/**
 * İki taraflı pazaryeri vurgusu: solda alıcı (turuncu), sağda satıcı (yeşil),
 * ortada "buluşma noktası". Eski alıcı-merkezli statik banner'ın yerini alır.
 *
 * Her iki CTA da prod'daki "İlan Ver" akışı gibi login-gate'li:
 * çıkış yapmış kullanıcı /login'e yönlenir, giriş sonrası geri döner.
 */
function HeroConvergence() {
  const history = useHistory();
  const isLogged = useSelector((state) => state.auth.isLogged);

  const goBuyer = () => requireLogin(history, isLogged, "/ilanOlustur");
  const goSeller = () => requireLogin(history, isLogged, "/satici/ilan-olustur");

  const arrowRight = (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 12h14" />
      <path d="M13 6l6 6-6 6" />
    </svg>
  );

  return (
    <div className="hc">
      <div className="hc__headline">Alıcı ile satıcı burada buluşur</div>

      {/* Alıcı tarafı */}
      <div className="hc__half hc__half--buyer">
        <div className="hc__decor">
          <svg width="150" height="150" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.2" strokeLinecap="round">
            <circle cx="11" cy="11" r="7" />
            <path d="M21 21l-4.3-4.3" />
          </svg>
        </div>
        <span className="hc__tag">
          <span className="hc__dot" />
          ALIYORUM
        </span>
        <div className="hc__copy">
          <p className="hc__lead">Aradığını yaz</p>
          <p className="hc__desc">Ne arıyorsan tarif et, satıcılar sana ulaşsın.</p>
        </div>
        <button type="button" className="hc__cta hc__cta--buyer" onClick={goBuyer}>
          İlan Ver {arrowRight}
        </button>
      </div>

      {/* Satıcı tarafı */}
      <div className="hc__half hc__half--seller">
        <div className="hc__decor">
          <svg width="150" height="150" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.2" strokeLinecap="round">
            <path d="M3 12V4h8l10 10-8 8L3 12z" />
            <circle cx="8" cy="9" r="1.2" fill="#fff" />
          </svg>
        </div>
        <span className="hc__tag">
          <span className="hc__dot" />
          SATIYORUM
        </span>
        <div className="hc__copy">
          <p className="hc__lead">Ürününü koy</p>
          <p className="hc__desc">Fotoğrafla, fiyat koy; alıcılar seni bulsun.</p>
        </div>
        <button type="button" className="hc__cta hc__cta--seller" onClick={goSeller}>
          İlan Ver {arrowRight}
        </button>
      </div>

      {/* Buluşma noktası — içe doğru bakan oklar iki tarafın birleşmesini anlatır. */}
      <div className="hc__center">
        <div className="hc__badge">
          <svg width="40" height="40" viewBox="0 0 48 24" fill="none" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
            <g className="hc__arrow--l" stroke="#F08A3E">
              <path d="M4 12h12" />
              <path d="M11 7l5 5-5 5" />
            </g>
            <g className="hc__arrow--r" stroke="#1EC28B">
              <path d="M44 12H32" />
              <path d="M37 7l-5 5 5 5" />
            </g>
          </svg>
        </div>
      </div>
    </div>
  );
}

export default HeroConvergence;
